var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMarkerCircle = function SvgIconMarkerCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.926 20.619q.072.05.152.088A9.96 9.96 0 0 0 12 22c1.79 0 3.469-.47 4.922-1.293q.08-.038.152-.088A10 10 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 3.67 1.978 6.88 4.926 8.619M4 12a8 8 0 1 1 13.5 5.81V16.5a1.75 1.75 0 0 0-1.5-1.732V12.75A1.75 1.75 0 0 0 14.25 11h-.671l-.857-3.087a.75.75 0 0 0-1.444 0L10.42 11H9.75A1.75 1.75 0 0 0 8 12.75v2.018A1.75 1.75 0 0 0 6.5 16.5v1.31A7.98 7.98 0 0 1 4 12m10 1v1.75h-4V13zm1.5 3.75h-7v2.446A8 8 0 0 0 12 20c1.255 0 2.443-.29 3.5-.804z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMarkerCircle;